@for (block of enhancedBlocks(); track block.id) {
    @switch (block.collection) {
        @case (BlockCollectionTypes.HEADER_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as headerBlockItem) {
                <packbo-header-block [headerBlock]="headerBlockItem" />
            }
        }

        @case (BlockCollectionTypes.ACCORDION_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as accordionBlockItem) {
                <packbo-accordion-block [accordionBlock]="accordionBlockItem" [isLast]="block.isLastAccordion" />
            }
        }

        @case (BlockCollectionTypes.PACKAGE_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as packageBlockItem) {
                <packbo-package-block [packageBlock]="packageBlockItem" [isFirst]="block.isFirstPackage" />
            }
        }

        @case (BlockCollectionTypes.RITCHTEXT_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as ritchtextBlockItem) {
                <packbo-ritchtext-block [ritchtextBlock]="ritchtextBlockItem" />
            }
        }

        @case (BlockCollectionTypes.CONTACT_FORM_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as contactFormBlockItem) {
                <packbo-contact-form-block [contactFormBlock]="contactFormBlockItem" />
            }
        }

        @case (BlockCollectionTypes.BUTTON_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as buttonBlockItem) {
                <packbo-button-block [buttonBlock]="buttonBlockItem" />
            }
        }

        @case (BlockCollectionTypes.BRONZE_SUBSCRIPTION_FORM_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as bronzeSubscriptionFormBlockItem) {
                <packbo-bronze-subscription-form-block
                    [bronzeSubscriptionFormBlock]="bronzeSubscriptionFormBlockItem"
                />
            }
        }

        @case (BlockCollectionTypes.LANDING_PAGE_SPLIT_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as landingPageSplitBlockItem) {
                <packbo-landing-page-split-block [landingPageSplitBlock]="landingPageSplitBlockItem" />
            }
        }

        @case (BlockCollectionTypes.PRODUCT_CATEGORIES_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as productCategoriesBlockItem) {
                <packbo-product-categories-block [productCategoriesBlock]="productCategoriesBlockItem" />
            }
        }

        @case (BlockCollectionTypes.AD_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as adBlockItem) {
                <packbo-ad-block [adBlock]="adBlockItem" />
            }
        }

        @case (BlockCollectionTypes.SUPPLIER_SHOWCASE_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as supplierShowcaseBlockItem) {
                <packbo-supplier-showcase-block [supplierShowcaseBlock]="supplierShowcaseBlockItem" />
            }
        }

        @case (BlockCollectionTypes.AD_LAYOUT_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as adLayoutBlockItem) {
                <packbo-ad-layout-block [adLayoutBlock]="adLayoutBlockItem" />
            }
        }

        @case (BlockCollectionTypes.PARTNER_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as partnerBlockItem) {
                <packbo-partner-block [partnerBlock]="partnerBlockItem" />
            }
        }

        @case (BlockCollectionTypes.FUNDING_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as fundingBlockItem) {
                <packbo-funding-block [fundingBlock]="fundingBlockItem" />
            }
        }

        @case (BlockCollectionTypes.RESOURCE_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as resourceBlockItem) {
                <packbo-resource-block [resourceBlock]="resourceBlockItem" [isLast]="block.isLastResource" />
            }
        }

        @case (BlockCollectionTypes.CONFIRMATION_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as confirmationBlockItem) {
                <packbo-confirmation-block [confirmationBlock]="confirmationBlockItem" />
            }
        }

        @case (BlockCollectionTypes.AD_PACKAGES_BLOCK) {
            @if (block.item | castBlockItem: block.collection; as adPackagesBlockItem) {
                <packbo-ad-packages-block [adPackagesBlock]="adPackagesBlockItem" />
            }
        }
    }
}
